import type { ReactNode } from 'react';

interface SectionCardProps {
  /** Optional section heading shown on the left of the card header. */
  title?: ReactNode;
  /** Optional content rendered on the right side of the header row (e.g. action buttons). */
  actions?: ReactNode;
  children: ReactNode;
  /** Extra Tailwind classes applied to the outer section element. */
  className?: string;
}

/** White card wrapper used for distinct sections on a page. */
export function SectionCard({ title, actions, children, className = '' }: SectionCardProps) {
  return (
    <section className={`bg-white rounded-xl p-6 mb-6 shadow-sm ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between mb-3">
          {title ? <h3 className="text-base font-bold m-0">{title}</h3> : <span />}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
